"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, FileText, Clock, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function The247DigitalEngine() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261081" id="the-247-digital-engine" className="bg-background text-foreground relative overflow-hidden ![padding:75px_0px_60px_0px]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-secondary/20 via-background to-background -z-10" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="flex flex-wrap gap-3">
              <Badge variant="secondary" className="px-3 py-1 text-sm font-mono bg-primary text-primary-foreground">
                <Clock className="mr-1.5 size-4" />
                Websites That Work While You Sleep
              </Badge>
              <Badge variant="outline" className="px-3 py-1 text-sm border-secondary/40 text-secondary font-mono">
                <ShieldCheck className="mr-1.5 size-4" />
                24/7 Digital Engine
              </Badge>
            </div>

            <div className="space-y-6">
              <h1 className="font-default text-4xl font-extrabold tracking-tighter text-foreground sm:text-5xl lg:text-6xl">
                The Engine That Powers Your Growth <span className="bg-gradient-to-r from-primary to-chart-3 bg-clip-text text-transparent">While You Sleep.</span>
              </h1>
              <p className="text-lg leading-relaxed text-muted-foreground sm:text-xl max-w-2xl">
                BlinkLab Media builds high-performance digital foundations for small businesses nationwide. From our Sumter hub, we deploy advanced technology and premium design to ensure your brand never stops working, even when you do.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" variant="secondary" className="w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:shadow-[0_0_20px_rgba(251,191,36,0.4)] transition-all animate-pulse">
                <Link to="/ContactPage">
                  Get Your Free Quote
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="w-full sm:w-auto text-base h-12 px-8 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground">
                <Link to="/AboutUsPage">
                  Our Agency Story
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 pt-4 text-sm font-medium text-muted-foreground">
              <div className="flex items-center gap-2">
                <Clock className="size-5 text-primary" />
                <span className="font-mono">Always Online</span>
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="size-5 text-secondary" />
                <span className="font-mono">Premium Security</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-lg lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-2xl bg-card/50 backdrop-blur-md p-2 shadow-2xl ring-1 ring-white/10">
              <div className="overflow-hidden rounded-xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_3d_abstract_eye_engine.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_3d_abstract_eye_engine.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_3d_abstract_eye_engine.png-wvc-sizes" alt="3D abstract render of a digital eye with circuit paths" className="w-full h-auto object-cover aspect-[4/3]" loading="eager" />
              </div>
              
              {}
              <div className="absolute -bottom-6 -left-6 rounded-lg bg-card p-4 shadow-3xl ring-1 ring-primary/30 flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary/20 text-primary">
                  <ShieldCheck className="size-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground font-default">BlinkLab Verified</p>
                  <p className="text-xs text-muted-foreground">Advanced Tech Stack</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}